import { RouteObject } from 'react-router-dom';

import { DashboardView } from '@/views/DashboardView/view.tsx';
import { DeviceDetailView } from '@/views/DeviceDetailView/view.tsx';
import { RewardsListView } from '@/views/RewardsListView/view.tsx';
import { SnapshotDetailView } from '@/views/SnapshotDetailView/view.tsx';

import { DeviceCheckinsListView } from './views/DeviceCheckinsListView/view.tsx';
import { SnapshotsListView } from './views/SnapshotsListView/view.tsx';

const routes: RouteObject[] = [
  { element: <DashboardView />, index: true },
  {
    path: '/devices/checkins',
    element: <DeviceCheckinsListView />
  },
  {
    path: '/devices/:deviceId',
    element: <DeviceDetailView />
  },
  {
    path: '/commissions',
    element: <RewardsListView />
  },
  {
    path: '/snapshots',
    element: <SnapshotsListView />
  },
  {
    path: '/snapshots/:ordinal',
    element: <SnapshotDetailView />
  }
];

export { routes };
